"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// import produce from 'immer';
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const assignChildContent_1 = require("./assignChildContent");
const deassignChildContent_1 = require("./deassignChildContent");
function getNonAssignedChildIds(rootContentId, enrolmentsByContentId, childContentIds) {
    return childContentIds.filter(contentId => {
        if (!enrolmentsByContentId[contentId]) {
            return true;
        }
        else if (enrolmentsByContentId[rootContentId].deleted === false &&
            (enrolmentsByContentId[contentId].deleted ||
                enrolmentsByContentId[contentId].parentIds.indexOf(rootContentId) === -1)) {
            return true;
        }
        return false;
    });
}
function getDeassignChildIds(rootContentId, enrolments, currentChildContentIds) {
    const childEnrolments = enrolments.filter(enrolment => (enrolment.parentIds || []).indexOf(rootContentId) >= 0);
    const allChildContentIds = childEnrolments.map(enrolment => enrolment.contentId);
    return allChildContentIds.filter(contentId => currentChildContentIds.indexOf(contentId) === -1);
}
const getChildContentsByContentId = (childContents) => keyBy_1.default(childContents, '_id');
const getCurrnetChildContentIds = (curriculumContent) => (curriculumContent.offers || []).map((offer) => offer.offerId);
function assignNonAssignedChild(command, content, childContents, states, enrolments, user) {
    try {
        const events = [];
        const childContentsByContentId = getChildContentsByContentId(childContents);
        const currentChildContentIds = getCurrnetChildContentIds(content);
        const { rootContentId } = command;
        const enrolmentsByContentId = keyBy_1.default(enrolments, enrolment => enrolment.contentId);
        const rootEnrolment = enrolmentsByContentId[rootContentId];
        const nonAssignedChildIds = getNonAssignedChildIds(rootContentId, enrolmentsByContentId, currentChildContentIds);
        if (nonAssignedChildIds.length > 0) {
            nonAssignedChildIds.map(contentId => {
                const currentContent = childContentsByContentId[contentId];
                const assignPayload = assignChildContent_1.assignChildContent(command, user, currentContent, states, enrolments, rootEnrolment);
                states = assignPayload.states;
                enrolments = assignPayload.enrolments;
                events.push(...assignPayload.events);
            });
        }
        return {
            states,
            enrolments,
            events
        };
    }
    catch (error) {
        throw error;
    }
}
function deassignRemovedChildContents(command, content, childContents, states, enrolments, user) {
    try {
        const events = [];
        const childContentsByContentId = getChildContentsByContentId(childContents);
        const currentChildContentIds = getCurrnetChildContentIds(content);
        const { rootContentId } = command;
        const enrolmentsByContentId = keyBy_1.default(enrolments, enrolment => enrolment.contentId);
        const rootEnrolment = enrolmentsByContentId[rootContentId];
        const deassignChildIds = getDeassignChildIds(rootContentId, enrolments, currentChildContentIds);
        if (deassignChildIds.length > 0) {
            deassignChildIds.map(contentId => {
                const currentContent = childContentsByContentId[contentId];
                const deassignPayload = deassignChildContent_1.deassignChildContent(command, user, currentContent, states, enrolments, rootEnrolment);
                states = deassignPayload.states;
                enrolments = deassignPayload.enrolments;
                events.push(...deassignPayload.events);
            });
        }
        return {
            states,
            enrolments,
            events
        };
    }
    catch (error) {
        throw error;
    }
}
function updateCurriculumChildContents(command, content, childContents, states, enrolments, user) {
    try {
        let events = [];
        const assignPayload = assignNonAssignedChild(command, content, childContents, states, enrolments, user);
        states = assignPayload.states;
        enrolments = assignPayload.enrolments;
        const deAssignPayload = deassignRemovedChildContents(command, content, childContents, states, enrolments, user);
        states = deAssignPayload.states;
        enrolments = deAssignPayload.enrolments;
        events = events.concat(assignPayload.events, deAssignPayload.events);
        return {
            states,
            enrolments,
            events
        };
    }
    catch (error) {
        throw new Error('Error in updateCurriculumChildContents ' + error);
    }
}
exports.updateCurriculumChildContents = updateCurriculumChildContents;
//# sourceMappingURL=updateCurriculumChildContent.js.map